import {
    ModuleSectionState,
    BackgroundType,
    BackgroundSettings
} from '../state';
import {
    ModuleSectionData,
    BackgroundSettingsPayload,
    StyleSettingsPayload
} from './payload';
import {StyleSettings, AvailableStyles} from './styles';

const backgroundTypesMap: { [type: string]: BackgroundType } = {
    'none': BackgroundType.None,
    'color': BackgroundType.Color,
    'image': BackgroundType.Image,
    'theming': BackgroundType.Theming
};

function serializeBackgroundType(type: BackgroundType) {
    let result = Object.keys(backgroundTypesMap)
        .filter(key => type === backgroundTypesMap[key]);

    return result.length ? result[0] : null;
}

export function serializeBackgroundSettings(background: BackgroundSettings) {
    let newBackground = {} as BackgroundSettingsPayload;

    newBackground.imageUrl = background.imageUrl;

    if (background.type !== undefined) {
        newBackground.type = serializeBackgroundType(background.type);
    }

    if (background.color !== undefined) {
        newBackground.color = background.color !== null ? [
            background.color.red, background.color.green, background.color.blue, background.color.alpha
        ] : null;
    }

    if (background.zone !== undefined) {
        newBackground.zone = background.zone;
    }

    if (background.shading !== undefined) {
        newBackground.shading = background.shading;
    }

    if (background.parallax !== undefined) {
        newBackground.parallax = background.parallax;
    }

    return newBackground;
}

export function unserializeBackgroundSettings(bgSettings: BackgroundSettingsPayload) {
    return {
        type: backgroundTypesMap[bgSettings.type],
        parallax: bgSettings.parallax,
        imageUrl: bgSettings.imageUrl,
        transformedImageUrl: bgSettings.transformedImageUrl,
        origImageUrl: bgSettings.origImageUrl,
        imageMediaType: bgSettings.imageMediaType ? bgSettings.imageMediaType.toLowerCase() : void 0,
        color: bgSettings.color ? {
            red: bgSettings.color[0],
            green: bgSettings.color[1],
            blue: bgSettings.color[2],
            alpha: bgSettings.color[3]
        } : null,
        zone: bgSettings.zone,
        shading: bgSettings.shading
    } as BackgroundSettings;
}

export function serializeStyleSettings(style: StyleSettings) {
    return {
        preset: style.preset.id,
        roundness: style.roundness.id,
        extras: style.extras.id
    } as StyleSettingsPayload;
}

export function unserializeStyleSettings(style: StyleSettingsPayload, availableStyles: AvailableStyles) {
    return {
        preset: availableStyles.presets.find(v => v.id === style.preset),
        roundness: availableStyles.roundness.find(v => v.id === style.roundness),
        extras: availableStyles.extras.find(v => v.id === style.extras)
    } as StyleSettings;
}

export function unserializePayload(moduleId: number, payload: ModuleSectionData) {
    let state = {
        moduleId: moduleId,
        layout: payload.layout,
        availableLayouts: payload.availableLayouts,
        availableStyles: payload.availableStyles,
        fullWidth: Boolean(payload.fullWidth),
        isFullWidthAvailable: payload.isFullWidthAvailable,
        toggles: payload.toggles,
        configurableGroups: payload.configurableGroups,
        innerElementModuleIds: payload.innerElementModuleIds,
        background: unserializeBackgroundSettings(payload.background),
        style: unserializeStyleSettings(payload.style, payload.availableStyles),
        quantity: payload.quantity,
        columns: payload.columns
    } as ModuleSectionState;

    return state;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/data/serialization.ts
 **/